
function AddressList(props) {
  return (
    <pre className="pre-scrollable">
      {props.addresses.map((value, index) => (
        <span
          key={index}
        >{value + "\n"}</span>
      ))}
    </pre>
  )
}

export default AddressList;
